import axios from "axios";

export default axios.create({
  baseURL: 'https://admin.v2.opioconvert.fr/api/',
  headers: {
    "Content-type": "application/json"
  }
})